import type { enKaohsiung } from './en.kaohsiung';

/** 高雄（繁體中文）。英語練習句保留英文。 */
export const zhTWKaohsiung: typeof enKaohsiung = {
  kaohsiung: {
    mapNames: { kaohsiung: '高雄' },
    zones: {
      kh_zuoying: '高鐵左營站',
      kh_lotus: '蓮池潭',
      kh_yancheng: '鹽埕老街',
      kh_loveRiver: '愛河',
      kh_formosa: '美麗島',
      kh_liuhe: '六合夜市',
      kh_pier2: '駁二藝術特區',
      kh_harbor: '高雄港',
    },
    objects: {
      kh_hsr: '高鐵左營站',
      kh_mrtZuoying: '高雄捷運・左營站（R16）',
      kh_mrtFormosa: '高雄捷運・美麗島站',
      kh_mrtYancheng: '高雄捷運・鹽埕埔站（O2）',
      kh_lotusView: '蓮池潭觀景台',
      kh_dragon: '龍虎塔',
      kh_dome: '光之穹頂',
      kh_papaya: '木瓜牛奶攤',
      kh_oyster: '蚵仔煎攤',
      kh_squid: '烤魷魚攤',
      kh_loveBoat: '愛之船售票處',
      kh_pier2: '駁二倉庫',
      kh_giants: '工人與漁婦巨人像',
      kh_lrt: '輕軌站・駁二大義',
      kh_lrtHamasen: '輕軌站・哈瑪星',
      kh_ferry: '旗津渡輪',
      kh_icecream: '旗津冰淇淋車',
      kh_tower85: '85大樓觀景台',
    },
    npc: {
      kh_stationStaff: '站務員',
      kh_monk: '法師',
      kh_domeGuide: '穹頂導覽員',
      kh_papayaVendor: '木瓜牛奶老闆',
      kh_oysterAuntie: '蚵仔煎阿姨',
      kh_boatman: '愛之船船長',
      kh_cyclist: '自行車騎士',
      kh_artist: '駁二藝術家',
      kh_fisher: '旗津漁夫',
      kh_surfer: '衝浪客',
      kh_kiteKid: '放風箏的男孩',
      kh_kiteGirl: '放風箏的女孩',
    },
    items: {},

    closed: '攤位還沒開。六合夜市下午五點才醒來！',
    kmrt: {
      name: '高雄捷運',
      ask: 'Which exit is this, please?',
      text: '高雄捷運：紅線南北向，橘線東西向，兩線在美麗島站交會。',
      to: { zuoying: '🔴 左營 — 高鐵站與蓮池潭', formosa: '🔴🟠 美麗島 — 光之穹頂與六合夜市', yancheng: '🟠 鹽埕埔 — 愛河與駁二' },
      riding: '小心月台間隙！列車滑進城市底下……',
    },
    lrt: {
      text: '高雄環狀輕軌是臺灣第一條輕軌（2015年）。它沒有架空電車線：列車在每一站停靠的二十秒內充電！',
      to: { pier2: '🚈 搭到駁二大義站（C12）', hamasen: '🚈 搭到哈瑪星與渡輪站（C14）' },
      ask: '❓ 為什麼沒有電線？',
      riding: '叮叮！綠色輕軌在草皮軌道上滑行。',
      q: 'Why does this tram have no overhead wires?',
      a: ['It charges its batteries at every stop.', 'It is pulled by horses.', 'It runs on wind power.'],
      right: '答對了！超級電容在乘客上下車的幾秒內就充飽電。',
      wrong: '停車時看看車頂：會伸出一根小手臂充電……',
    },
    dome: {
      text: '光之穹頂就在你腳下的美麗島站：直徑30公尺、4,500片彩色玻璃，是世界最大的玻璃藝術品，講述水、土、光、火的故事。',
      ask: '🌈 學一個知識（英語）',
      q: 'What is the Dome of Light made of?',
      a: ['Coloured glass — four thousand five hundred pieces.', 'Plastic bottles.', 'Paper lanterns.'],
      right: '沒錯！義大利藝術家水仙大師（Narcissus Quagliata）花了四年創作。',
      wrong: '看看樓梯上方玻璃殼透出的色彩……',
    },
    dragon: {
      text: '龍虎塔矗立在蓮池潭上。要從龍口「進」、虎口「出」——這樣能把壞運變好運！',
      ask: '🐉 從哪邊進去？（英語）',
      q: 'Which mouth do you walk in through?',
      a: ['In through the dragon, out through the tiger.', 'In through the tiger, out through the dragon.', 'It doesn’t matter.'],
      right: '完全正確！龍進虎出，今天剩下的時間都有好運。',
      wrong: '小心！反過來走會帶來壞運。先走龍……',
    },
    lotus: {
      text: '蓮池潭是一座42公頃、四周環繞寺廟的湖。夏天開滿粉紅蓮花。對岸的北極玄天上帝像高72公尺，是世界最高的水上神像。',
      look: '🔭 用望遠鏡看看',
      looked: '龍與虎、兩座樓閣，還有一位持劍立於水上的巨大神明。一隻白鷺飛過。',
      phrase: 'Look! A giant statue on the water!',
    },
    food: {
      papaya: { vendor: 'Papaya milk, fresh and cold! Large or small?', ok: 'A large papaya milk, please.', bad: ['Papaya. Milk. Now.', 'Give me the orange one.'], done: '香甜、濃郁、冰涼——一杯裝下整個高雄。老闆眨眨眼：「六合第一名！」', price: 30 },
      oyster: { vendor: 'Oyster omelette! Hot off the griddle. With sweet sauce?', ok: 'Yes, please. One oyster omelette with sauce.', bad: ['Omelette! Fast!', 'Oysters. Mine.'], done: '邊緣酥脆、中間Q彈、蚵仔肥美，再淋上甜辣醬。好吃！', price: 35 },
      squid: { vendor: 'Grilled squid! Spicy or not spicy?', ok: 'Not spicy, please. One grilled squid.', bad: ['Squid. Give.', 'I want the whole sea.'], done: '煙燻香、有嚼勁，刷了醬油和芝麻。你跟大家一樣拿著竹籤直接吃。', price: 40 },
      icecream: { vendor: 'Cijin ice cream! Mango, peanut or taro?', ok: 'One mango ice cream, please.', bad: ['Ice. Cream. Mango.', 'I want all of them for free.'], done: '冰涼果香，海風吹來，一隻海鷗盯著你的甜筒。完美！', price: 25 },
    },
    boat: {
      text: '愛之船沿著愛河穿過一座座橋。夜裡河岸亮起粉紅、紫色和藍色的燈光。',
      buy: '🎫 買票（英語）',
      q: 'How do you ask for a ticket politely?',
      a: ['Two tickets for the Love Boat, please.', 'Boat. Ticket. Now.', 'Take me somewhere.'],
      right: '船滑過橋下。棕櫚樹搖曳，燈柱上的愛心發亮，船長向每一艘船揮手。',
      wrong: '船長微笑：“Could you say that more politely?”',
      price: 40,
      poor: '你的硬幣不夠搭船。',
    },
    pier2: {
      text: '駁二藝術特區：這些紅磚倉庫在1970年代為港口儲存砂糖與魚粉。荒廢多年後，2006年變成工作室、藝廊和滑板廣場。',
      ask: '🎨 學一個知識（英語）',
      q: 'What were these buildings before they were an art centre?',
      a: ['Port warehouses for sugar and fish meal.', 'A train station.', 'A school.'],
      right: '答對了！現在舊鐵軌穿過廣場，牆上滿是壁畫。',
      wrong: '看看大門和地上的鐵軌……',
    },
    giants: {
      text: '駁二的巨人像：一位碼頭工人和一位漁婦，色彩鮮豔、方方正正，紀念建設港口的人們。',
      pose: '💪 擺出巨人的姿勢',
      posed: '雙手高舉、抬頭挺胸！遊客笑著幫你和巨人合照。',
      phrase: 'The worker is strong. The fisherwoman is brave.',
    },
    ferry: {
      text: '鼓山渡輪橫渡高雄港到旗津，那裡有燈塔、黑沙海灘和海產街。機車也能一起上船！',
      ask: '⛴️ 學一個知識（英語）',
      q: 'How long does the ferry to Cijin take?',
      a: ['About five minutes.', 'Two hours.', 'All day.'],
      right: '沒錯！五分鐘就過海——而且機車先上船。',
      wrong: '往港口對面看：從這裡就看得到旗津……',
    },
    tower: {
      text: '高雄85大樓高347公尺：兩條腿加一座中央塔，形狀像「高」字——高雄的第一個字。在台北101落成前，它是臺灣最高的建築。',
      ask: '🏙️ 學一個知識（英語）',
      q: 'Which Chinese character is the tower shaped like?',
      a: ['高 — “tall”, the first character of Kaohsiung.', '大 — “big”.', '山 — “mountain”.'],
      right: '答對了！兩條腿撐起高高的中間，就像「高」。',
      wrong: '看看它的形狀：兩條腿撐著一座高塔……',
    },

    talk: {
      kh_stationStaff: {
        intro: '歡迎來到高雄！這裡一年四季都是晴天。需要幫你找什麼嗎？',
        q: 'How do you ask where the MRT is?',
        a: ['Excuse me, where is the MRT station?', 'MRT. Where.', 'Take me to the MRT!'],
        right: '很有禮貌！捷運入口就在廣場上，你的右手邊。',
        wrong: '試著用 “Excuse me…” 開頭。',
      },
      kh_domeGuide: {
        intro: '歡迎來到美麗島站！樓梯下面就是光之穹頂。猜猜它可以用來做什麼？',
        q: 'Which of these happens under the Dome of Light?',
        a: ['Weddings — couples get married under the glass!', 'Swimming races.', 'Football matches.'],
        right: '對！每年都有新人選在這一站拍婚紗照。',
        wrong: '想想浪漫的事，有色彩、有光……',
      },
      kh_monk: [
        '龍口進，虎口出。慢慢走——在蓮池潭不用急。',
        'English practice: “Good morning.” — “Good morning. Peace be with you.”',
        '蓮花出淤泥而不染，在陽光下潔淨綻放。所以我們愛它。',
      ],
      kh_papayaVendor: [
        '高雄的木瓜最甜——太陽把工作都做完了！',
        'English practice: “Would you like ice in it?” — “Yes, please. Lots of ice!”',
        '這攤是我阿嬤開的。一樣的配方，一樣的果汁機聲音！',
      ],
      kh_oysterAuntie: [
        '每天早上從潟湖來的新鮮蚵仔。外酥內軟！',
        'English practice: “Is it spicy?” — “Just a little.”',
        '夜市守則：吃、逛、再吃！',
      ],
      kh_boatman: [
        'English practice: “All aboard!” — 船準備好時我就這樣喊。',
        '愛河以前很髒。現在大家在河岸划船、跑步、唱卡拉OK！',
        '順流三十分鐘再回來。靠近港口的橋最低。',
      ],
      kh_cyclist: [
        'English practice: “Passing on your left!”',
        '從愛河可以一路騎到港口和駁二——全程平路。',
        '河邊的棕櫚樹？它們傾斜是因為每天下午都吹海風。',
      ],
      kh_artist: [
        '我畫鯨魚。高雄是港都，海無所不在。',
        'English practice: “What are you painting?” — “A whale, and a tram, and the sun.”',
        '廣場上的舊鐵軌以前把砂糖運到船上。現在滑板從上面滑過。',
      ],
      kh_fisher: [
        '我住在旗津。渡輪只要五分鐘，卻像另一座島。',
        'English practice: “Did you catch anything?” — “A big one! It got away.”',
        '大船進港時水面會漲——抓好帽子！',
      ],
      kh_surfer: [
        '旗津冬天有浪，還有黑沙海灘。全臺灣最美的夕陽！',
        'English practice: “Can you swim?” — “Yes, I can. Can you surf?”',
        '渡輪讓我的衝浪板免費上船。機車要多付一點。',
      ],
      kh_kiteKid: [
        '我的風箏是龍風箏！有十二條尾巴。',
        'English practice: “Hold the string tight!” — “I’ve got it!”',
      ],
      kh_kiteGirl: [
        '下午的海風最適合放風箏。等一下……就是現在！',
        'English practice: “Look how high it is!” — “Higher than the 85 tower!”',
      ],
    },
  },
};
